import axios from "axios";

const SERVER = (import.meta.env.VITE_URL_SERVER as string | undefined)?.replace(/\/$/, "") ?? "";
const BASE_PATH = (import.meta.env.VITE_API_BASE_PATH as string | undefined) ?? "/monparcours";

const apiClient = axios.create({
  baseURL: `${SERVER}${BASE_PATH}`,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    'X-Tenant-ID': "CIRCUIT"
  },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("id_user");
      if (!window.location.pathname.startsWith("/signin") && !window.location.pathname.startsWith("/callback")) {
        window.location.href = "/signin";
      }
    }
    return Promise.reject(error);
  },
);

export default apiClient;
